__turbopack_context__.v({
  "addPill": "sN9A7q_addPill",
  "addPillNeedsFill": "sN9A7q_addPillNeedsFill",
  "badgesWrapper": "sN9A7q_badgesWrapper",
  "keywordsLabel": "sN9A7q_keywordsLabel",
  "keywordsWrapper": "sN9A7q_keywordsWrapper",
  "section": "sN9A7q_section",
});
